<div class="modal-container">
    <div class="modal-header">
        <div class="modal-title">
            ASSET SELECTION
        </div>
        <div class="modal-close-button" (click)="onCloseButtonClick()">
            <img src="" class="closeIcon" />
        </div>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="!assetsLoading">
            <div class="header">
                <div class="title">Select Assets for {{selectedPlant.plantName}}</div>
                <div class="note">Note: The disabled items have already been configured!</div>
            </div>
            
            <div class="asset-options-container" *ngIf="assetList.length > 0 || disabledAssetList.length > 0">
                <div class="options">
                    <mat-checkbox 
                        (change)="selectAll($event.checked)" 
                        [checked]="allSelected"
                        [indeterminate]="someSelected"
                        [disabled]="disabledSelectAll">
                        <div class="asset-options-text">
                            Select All
                        </div>
                    </mat-checkbox> 
                    <ng-container  *ngFor="let asset of assetList">
                        <mat-checkbox
                        [(ngModel)]="asset.selected"
                        (ngModelChange)="onAssetSelected()" >
                            <span appTooltip="{{asset.assetName}}" [tooltipPosition]="'top'"
                            [tooltipShow]="(asset.assetName.length) > 24">
                                <div class="asset-options-text">
                                    {{asset.assetName | shorten: 24}}
                                </div>
                            </span>
                        </mat-checkbox>
                    </ng-container>
                    <ng-container *ngFor="let disabledAsset of disabledAssetList">
                        <mat-checkbox disabled>
                            <span appTooltip="{{disabledAsset.assetName}}" [tooltipPosition]="'top'"
                            [tooltipShow]="(disabledAsset.assetName.length) > 24">
                                <div class="asset-options-text disabled">
                                    {{disabledAsset.assetName | shorten: 24}}
                                </div>
                            </span>
                        </mat-checkbox>
                    </ng-container>
                </div>
            </div>
            <div class="no-asset-message" *ngIf="assetList.length == 0 && disabledAssetList.length == 0">
                <img class="icon infoIcon" src=""/>
                <div class="message">No available assets to configure</div>
            </div>
            <div class="select-button-container">
                <button (click)="submit()" [ngClass]="{'select-button-disabled': !allSelected && !someSelected, 'select-button-enabled' : allSelected || someSelected}" [disabled]="!allSelected && !someSelected">
                    <div class="select-button-text">
                        SELECT({{count}})
                    </div>
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="assetsLoading">
            <div class="loading-assets">
                <app-three-dots-loading class="dots"></app-three-dots-loading>
                <div class="text">Loading Assets...</div>
            </div>
        </ng-container>
    </div>
</div>